import React from "react";
import combineClassName from "./utils/combineClassName";

interface ContainerProps {
  children?: React.ReactNode;
  className?: string;
}
export default function Container({ children, className }: ContainerProps) {
  return (
    <div
      className={combineClassName([
        "bg-white py-4 px-6 w-full rounded-lg shadow-md border border-[#E0E0E0]",
        className,
      ])}
    >
      {children}
    </div>
  );
}
